import { render, staticRenderFns } from "./EvidenceFilter.vue?vue&type=template&id=bcb2189c&scoped=true&name=filtering&"
import script from "./EvidenceFilter.vue?vue&type=script&lang=js&"
export * from "./EvidenceFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb2189c",
  null
  
)

export default component.exports